import React from "react";

import { StorageKeys } from "@origin-digital/platform-enums";

import { BannerView } from "./BannerView";
import {
  isAfterLocalTime,
  updateLocalStorage,
  loadContent,
  CrisisBannerContent
} from "./helpers";

interface IState {
  show: boolean;
  content: CrisisBannerContent | undefined;
}
export class CrisisBanner extends React.Component<any, IState> {
  state: IState = {
    show: false,
    content: undefined
  };

  onCloseButtonClick = () => {
    updateLocalStorage(StorageKeys.crisisBanner, { status: "close" });
    this.setState({ show: false });
  };

  async componentDidMount() {
    try {
      const { status, content } = await loadContent(StorageKeys.crisisBanner);
      if (status === "open" && (content && content.enabled === "true")) {
        const bannerContent = content as CrisisBannerContent;
        const { start, end } = bannerContent;

        if (!isAfterLocalTime(start) && isAfterLocalTime(end)) {
          return this.setState({
            show: true,
            content: bannerContent
          });
        }
      }
    } catch (error) {
      console.log("CrisisBanner Error:", error);
    }
  }

  render() {
    const { show, content } = { ...this.state } as IState;
    return show && content ? (
      <BannerView
        type={content.type}
        heading={content.heading}
        message={content.msg}
        link={content.link}
        linkText={content.linkText}
        onCloseButtonClick={this.onCloseButtonClick}
        closeBtnDataId={"cbCloseBtn"}
      />
    ) : null;
  }
}
